// Real content & images for Decatur Solution Works

export const COMPANY = {
  name: "Decatur Solution Works",
  tagline: "Same-Day Appliance Repair in Decatur, GA",
  phone: "(678) 525-0474",
  phoneRaw: "+16785250474",
  email: "decatursolutionworks@gmail.com",
  address: "2318 Newgate Drive, Decatur, GA 30035",
  hours: "Mon-Fri: 8AM - 6PM | Sat-Sun: 10AM - 6PM",
  hoursLong: "Monday-Friday 8 AM to 6 PM, Saturday-Sunday 10 AM to 6 PM. Emergency service available outside business hours (emergency rate applies).",
  rating: 5.0,
  reviews: 6,
  yearsExperience: 18,
};

export const NAV_LINKS = [
  { label: "Home", href: "/" },
  { label: "Services", href: "/#services" },
  { label: "Service Area", href: "/#area" },
  { label: "Reviews", href: "/#reviews" },
  { label: "Blog", href: "/blog" },
  { label: "Contact", href: "/contact" },
];

// Structured navigation menu used by Header.jsx for desktop dropdowns and the
// mobile hamburger panel. Keep these slugs synced with /src/data/* and the
// generate-sitemap.js script.
export const NAV_MENU = [
  { type: "link", label: "Home", href: "/" },
  {
    type: "dropdown",
    label: "Residential Services",
    items: [
      // Symptom-first pages (highest search volume)
      { label: "Diagnostic Guides", href: "/guides", desc: "Free troubleshooting guides from our techs" },
      { label: "Refrigerator Repair", href: "/refrigerator-repair", desc: "Same-day fridge repair near you" },
      { label: "Fridge Not Cooling But Lights On", href: "/fridge-not-cooling-but-lights-on", desc: "Fan, relay, defrost, compressor" },
      { label: "Refrigerator Leaking Water", href: "/refrigerator-leaking-water", desc: "Defrost drain, drain pan, water valve" },
      { label: "Washing Machine Repair", href: "/washing-machine-repair", desc: "Won't spin, leaking, shaking" },
      { label: "Washer Won't Drain", href: "/washer-wont-drain", desc: "Drain pump, filter, hose" },
      { label: "Dryer Repair — Not Heating", href: "/dryer-repair-not-heating", desc: "Element, fuse, igniter, vent" },
      { label: "Oven Repair", href: "/oven-repair", desc: "Not heating, won't hold temp" },
      { label: "Stove & Cooktop Repair", href: "/stove-repair", desc: "Burner won't light, clicking igniter" },
      { label: "Dishwasher Repair — Not Draining", href: "/dishwasher-repair-not-draining", desc: "Standing water, leaking, not cleaning" },
      // Water line, dispenser & ice maker
      { label: "Refrigerator Water Line Installation", href: "/refrigerator-water-line-installation", desc: "New water line & ice maker hookup" },
      { label: "Refrigerator Water Line Repair", href: "/refrigerator-water-line-repair", desc: "Leaks, burst lines, valves" },
      { label: "Refrigerator Not Dispensing Water", href: "/refrigerator-not-dispensing-water", desc: "Filter, frozen tank, inlet valve" },
      { label: "Ice Maker Not Working", href: "/refrigerator-ice-maker-not-working", desc: "Jammed mold, module, water supply" },
      // Refrigerators
      { label: "Samsung & LG Dual-Cool Refrigerator Repair", href: "/dual-cool-refrigerator-repair", desc: "Twin Cooling, CoolGuard, dual-evaporator" },
      { label: "LG Refrigerator Repair", href: "/lg-refrigerator-repair", desc: "Linear compressor & ice maker specialists" },
      { label: "GE Refrigerator Repair", href: "/ge-refrigerator-repair", desc: "GE, Profile, Monogram & Café" },
      { label: "Whirlpool Refrigerator Repair", href: "/whirlpool-refrigerator-repair", desc: "Whirlpool, Maytag, Amana & KitchenAid" },
      // Washers & Dryers
      { label: "Samsung Washer Repair", href: "/samsung-washer-repair", desc: "Banging noise, not draining, not filling" },
      { label: "Samsung Dryer Repair", href: "/samsung-dryer-repair", desc: "Not heating, squeaking, thumping noise" },
      { label: "Whirlpool Dryer Repair", href: "/whirlpool-dryer-repair", desc: "Thermal fuse, squeaking, won't tumble" },
      // Cooking
      { label: "Gas Stove & Oven Repairs", href: "/gas-stove-repairs", desc: "Igniter, safety gas valve, temperature sensor" },
      // Installation
      { label: "Appliance Installation", href: "/appliance-installation", desc: "Washers, dryers, fridges, ranges, dishwashers, microwaves" },
    ],
  },
  {
    type: "dropdown",
    label: "Brands We Service",
    items: [
      { label: "Samsung Repairs", href: "/samsung", desc: "Family Hub, Bespoke, FlexWash" },
      { label: "LG Repairs", href: "/lg", desc: "InstaView, TurboWash, ThinQ" },
      { label: "Whirlpool Repairs", href: "/whirlpool", desc: "Authorized dealer service" },
      { label: "GE Repairs", href: "/ge", desc: "GE, Profile, Monogram, Cafe" },
      { label: "Bosch Repairs", href: "/bosch", desc: "E15, Ascenta to Benchmark" },
      { label: "Frigidaire Repairs", href: "/frigidaire", desc: "Gallery, Professional" },
      { label: "KitchenAid Repairs", href: "/kitchenaid", desc: "Built-in & pro-style" },
      { label: "Maytag Repairs", href: "/maytag", desc: "Bravos, Centennial, Maxima" },
      { label: "Kenmore Repairs", href: "/kenmore", desc: "Kenmore & Kenmore Elite" },
      { label: "Sub-Zero Repairs", href: "/sub-zero", desc: "Built-in & integrated refrigeration" },
      { label: "Wolf Repairs", href: "/wolf", desc: "Pro ranges, wall ovens, rangetops" },
    ],
  },
  {
    type: "dropdown",
    label: "Commercial",
    items: [
      { label: "Commercial Refrigeration Repair", href: "/commercial-refrigeration", desc: "Walk-in coolers, freezers, ice machines, reach-ins" },
      { label: "Refrigeration & Rack Repairs", href: "/commercial-refrigeration-rack-repair", desc: "True, Hussmann, Hill Phoenix, walk-ins" },
      { label: "Commercial Appliance Repair", href: "/commercial-appliance-repair", desc: "Restaurants, hotels, laundromats" },
      { label: "Preventive Maintenance Plans", href: "/preventive-maintenance", desc: "Bronze / Silver / Gold quarterly PM tiers" },
      { label: "Supermarket Refrigeration", href: "/walmart-supercenter-refrigeration", desc: "Supercenter & grocery rack systems" },
      { label: "True Refrigeration Repair", href: "/true", desc: "Reach-ins, prep tables, glass-door coolers" },
    ],
  },
  {
    type: "dropdown",
    label: "Service Area",
    items: [
      { label: "All Service Areas", href: "/service-area", desc: "Every city we cover" },
      { label: "Decatur GA", href: "/appliance-repair-decatur", desc: "Our HQ · 30030, 30032, 30033, 30034, 30035" },
      { label: "Atlanta (intown)", href: "/appliance-repair-atlanta", desc: "Midtown, Buckhead, Inman Park" },
      { label: "Sandy Springs", href: "/appliance-repair-sandy-springs", desc: "30328, 30342, 30350 · premium brands" },
      { label: "Dunwoody", href: "/appliance-repair-dunwoody", desc: "Perimeter Mall · Sub-Zero specialists" },
      { label: "Stone Mountain", href: "/appliance-repair-stone-mountain", desc: "30083, 30087, 30088" },
      { label: "Tucker", href: "/appliance-repair-tucker", desc: "30084 · Northlake area" },
      { label: "Lithonia", href: "/appliance-repair-lithonia", desc: "30038, 30058 · Stonecrest" },
      { label: "Conyers", href: "/appliance-repair-conyers", desc: "30012, 30013, 30094" },
      { label: "Snellville", href: "/appliance-repair-snellville", desc: "30039, 30078" },
      { label: "Lilburn", href: "/appliance-repair-lilburn", desc: "30047" },
      { label: "Norcross", href: "/appliance-repair-norcross", desc: "30071, 30092, 30093" },
      { label: "Chamblee", href: "/appliance-repair-chamblee", desc: "30341, 30366" },
      { label: "Doraville", href: "/appliance-repair-doraville", desc: "30340, 30360 · Buford Hwy" },
      { label: "Avondale Estates", href: "/appliance-repair-avondale-estates", desc: "30002 · Tudor homes" },
      { label: "Clarkston", href: "/appliance-repair-clarkston", desc: "30021" },
      { label: "Scottdale", href: "/appliance-repair-scottdale", desc: "30079" },
      { label: "East Point", href: "/appliance-repair-east-point", desc: "30344, 30354" },
      { label: "College Park", href: "/appliance-repair-college-park", desc: "30337, 30349 · airport area" },
      { label: "Forest Park", href: "/appliance-repair-forest-park", desc: "30297 · Tradeport" },
      { label: "Ellenwood", href: "/appliance-repair-ellenwood", desc: "30294" },
      { label: "Morrow", href: "/appliance-repair-morrow", desc: "30260 · Southlake Mall" },
      { label: "Stockbridge", href: "/appliance-repair-stockbridge", desc: "30281 · Eagle's Landing" },
      { label: "Riverdale", href: "/appliance-repair-riverdale", desc: "30274, 30296" },
      { label: "Jonesboro", href: "/appliance-repair-jonesboro", desc: "30236, 30238 · Tara area" },
    ],
  },
];

export const SERVICES = [
  {
    id: "washer",
    title: "Washer Repair",
    linkText: "Learn more about Samsung & Whirlpool washer repair",
    short: "Whirlpool, Kenmore & related brands",
    description:
      "Drainage problems, spin cycle failures, leaks, and control board issues handled same-day. Factory-trained on top-load and front-load washers.",
    image: "/site-images/avknwmtn_washer-wont-drain-water-repair-decatur-jpg-standard.webp",
    brands: ["Whirlpool", "Kenmore", "Maytag", "Amana", "KitchenAid", "JennAir"],
    issues: ["Won't drain", "Won't spin", "Leaking water", "Control board failure"],
    startingAt: 89,
    href: "/samsung-washer-repair",
  },
  {
    id: "dryer",
    title: "Dryer Repair",
    linkText: "Learn more about Samsung dryer repair",
    short: "Gas & electric — all brands",
    description:
      "Dryers not heating, making noise, or not spinning? We repair gas and electric dryers from every major manufacturer.",
    image: "/site-images/remote/19988ea473.webp",
    brands: ["Samsung", "Whirlpool", "Amana", "Frigidaire", "Kenmore", "Hotpoint", "LG"],
    issues: ["No heat", "Won't tumble", "Burning smell", "Stops mid-cycle"],
    startingAt: 89,
    href: "/samsung-dryer-repair",
  },
  {
    id: "refrigerator",
    title: "Refrigerator Repair",
    linkText: "Learn more about LG refrigerator repair",
    short: "Premium & high-end brands",
    description:
      "From compressor and ice-maker issues to thermostat and door-seal repair. Certified on Sub-Zero, Monogram, KitchenAid, and Bosch.",
    image: "/site-images/remote/4030a1b170.webp",
    brands: ["Samsung", "LG", "Frigidaire", "GE", "GE Monogram", "KitchenAid", "Bosch", "Sub-Zero", "Viking", "Whirlpool"],
    issues: ["Not cooling", "Ice maker broken", "Leaking water", "Loud compressor"],
    startingAt: 99,
    href: "/lg-refrigerator-repair",
  },
  {
    id: "oven",
    title: "Stove & Oven Repair",
    linkText: "Learn more about gas stove & oven repair",
    short: "All brands — gas & electric",
    description:
      "Gas stove repair and electric oven repair for every brand. Burners, igniters, bake elements, thermostats, and control boards — fixed safely.",
    image: "/site-images/remote/ced2341856.webp",
    brands: ["Samsung", "LG", "Whirlpool", "GE", "Frigidaire", "Kenmore", "KitchenAid", "Bosch"],
    issues: ["Burner won't light", "Oven not heating", "Igniter clicking", "Wrong temperature"],
    startingAt: 95,
    href: "/gas-stove-repairs",
  },
];

export const ADDITIONAL_SERVICES = [
  {
    title: "Ice Maker Repair & Installation",
    linkText: "Learn more about ice maker repair & installation",
    description:
      "Ice maker not working? We repair and install ice makers for every refrigerator brand — fixed today.",
    icon: "Snowflake",
    href: "/lg-refrigerator-repair",
  },
  {
    title: "Refrigerator Waterline Installation",
    linkText: "Learn more about refrigerator water line installation",
    description:
      "Clean, leak-free waterline installation for ice makers and water dispensers — guaranteed.",
    icon: "Droplets",
    href: "/appliance-installation",
  },
  {
    title: "Appliance Installation",
    linkText: "Learn more about appliance installation",
    description:
      "We install washers, dryers, refrigerators, stoves, and dishwashers with proper connections and testing.",
    icon: "Wrench",
    href: "/appliance-installation",
  },
  {
    title: "Dryer Vent Cleaning",
    linkText: "Learn more about dryer vent cleaning",
    description:
      "Full vent line cleaned from the dryer to the exterior vent, airflow checked and dryer tested — lower fire risk and faster drying.",
    icon: "Wind",
    href: "/dryer-vent-cleaning",
  },
];

export const BRAND_SPECIALISTS = [
  { name: "Whirlpool", desc: "All Whirlpool Appliances" },
  { name: "Samsung", desc: "Washers, Dryers & Fridges" },
  { name: "LG", desc: "All LG Appliances" },
  { name: "GE", desc: "GE, Profile & Monogram" },
  { name: "Frigidaire", desc: "All Frigidaire Appliances" },
];

export const BRANDS = [
  "Samsung", "LG", "Whirlpool", "GE", "Frigidaire", "Kenmore",
  "Bosch", "KitchenAid", "Amana", "Hotpoint", "GE Monogram", "Sub-Zero",
];

export const SERVICE_AREAS = [
  "Decatur", "Avondale Estates", "Scottdale", "Stone Mountain", "Tucker", "Clarkston",
  "Lithonia", "Conyers", "Snellville", "Lilburn", "Norcross", "Chamblee", "Doraville",
  "Dunwoody", "Sandy Springs", "East Point", "College Park", "Forest Park", "Ellenwood",
  "Morrow", "Stockbridge", "Riverdale", "Jonesboro", "Atlanta",
  "Pine Lake", "Stonecrest", "Belvedere Park", "Candler-McAfee", "Druid Hills",
  "Gresham Park", "North Decatur", "North Druid Hills", "Panthersville", "Redan",
  "East Atlanta", "Brookhaven", "Smyrna", "Lawrenceville", "Marietta", "Mableton",
  "McDonough", "Union City", "Fairburn", "Duluth", "Peachtree Corners", "Lakeside / Toco Hills",
];

export const COMMON_PROBLEMS = [
  {
    title: "Samsung Dryer Not Heating?",
    linkText: "Learn more about Samsung dryer not heating repair",
    desc: "Home dryer running but clothes still wet? We're heating-element specialists — thermostats, thermal fuses, and heating coils all fixed same-day.",
    badges: ["Samsung"],
    href: "/samsung-dryer-repair",
    image: "/site-images/remote/19988ea473.webp",
  },
  {
    title: "Whirlpool Washer Not Draining?",
    linkText: "Learn more about washer not draining repair",
    desc: "Whirlpool or Kenmore home washer won't drain or spin? Fast diagnosis and same-day repair across Decatur and DeKalb County.",
    badges: ["Whirlpool", "Kenmore"],
    href: "/samsung-washer-repair",
    image: "/site-images/avknwmtn_washer-wont-drain-water-repair-decatur-jpg-standard.webp",
  },
  {
    title: "LG Refrigerator Not Cooling?",
    linkText: "Learn more about LG refrigerator not cooling repair",
    desc: "LG home fridge warm but freezer cold? This is a common LG issue we resolve daily. Quick diagnostic, lasting fix.",
    badges: ["LG"],
    href: "/lg-refrigerator-repair",
    image: "/site-images/remote/de1edb6a52.webp",
  },
  {
    title: "GE Ice Maker Broken?",
    linkText: "Learn more about GE ice maker repair",
    desc: "GE or GE Monogram home ice maker not producing ice? We service all GE models including Profile and Monogram.",
    badges: ["GE", "GE Monogram"],
    href: "/ge-refrigerator-repair",
    image: "/site-images/remote/4030a1b170.webp",
  },
  {
    title: "Gas Stove Burner Not Lighting?",
    linkText: "Learn more about gas stove burner repair",
    desc: "Igniter clicking but not lighting? We repair every residential gas stove and oven brand — igniters, gas valves, and burner assemblies.",
    badges: ["All Brands"],
    href: "/gas-stove-repairs",
    image: "/site-images/remote/ced2341856.webp",
  },
  {
    title: "Washer Leaking Water?",
    linkText: "Learn more about leaking washer repair",
    desc: "Pooling water around your home washer? Hoses, pumps, door seals — we find the source and fix it in one visit.",
    badges: ["All Brands"],
    href: "/samsung-washer-repair",
    image: "/site-images/remote/7c3be09b56.webp",
  },
];

export const FEATURES = [
  {
    title: "Same-Day Service",
    description: "Emergency calls prioritized across Decatur, Stone Mountain, Lithonia, Tucker & Conyers.",
    icon: "Zap",
  },
  {
    title: "1-year parts & labor warranty (one year on OEM parts)",
    description: "Every washer, dryer, fridge and oven repair backed by a 1-year parts & labor warranty (one year on OEM parts).",
    icon: "ShieldCheck",
  },
  {
    title: "Pay Upon Completion",
    description: "You only pay once your appliance runs perfectly. Transparent pricing, no hidden fees.",
    icon: "DollarSign",
  },
  {
    title: "Factory-Trained Techs",
    description: "Certified on Samsung, LG, GE, Whirlpool, Frigidaire, KitchenAid, Bosch & more.",
    icon: "Award",
  },
];

export const TESTIMONIALS = [
  {
    name: "Marcus T.",
    location: "Decatur, GA",
    rating: 5,
    text: "Called about my Samsung dryer not heating. They came out same day and had it fixed in under an hour. Factory-trained technician knew exactly what the problem was. Highly recommend.",
    service: "Samsung Dryer Repair",
    when: "2 weeks ago",
  },
  {
    name: "Keisha W.",
    location: "Stone Mountain, GA",
    rating: 5,
    text: "My Whirlpool washer wasn't draining and was leaking water everywhere. Decatur Solution Works diagnosed it fast and fixed it on the spot. Fair pricing and great communication.",
    service: "Whirlpool Washer Repair",
    when: "1 month ago",
  },
  {
    name: "David R.",
    location: "Lithonia, GA",
    rating: 5,
    text: "LG refrigerator stopped cooling and I was about to lose all my food. They came out within 2 hours and got it running again. The diagnostic fee was credited toward the repair. Very professional.",
    service: "LG Refrigerator Repair",
    when: "3 weeks ago",
  },
  {
    name: "Sandra J.",
    location: "Tucker, GA",
    rating: 5,
    text: "Our GE Monogram ice maker stopped working. Other companies said they don't service high-end brands but Decatur Solution Works fixed it no problem. Factory-trained techs make the difference.",
    service: "GE Monogram Repair",
    when: "1 month ago",
  },
  {
    name: "James P.",
    location: "Conyers, GA",
    rating: 5,
    text: "Gas stove burner wasn't lighting. They replaced the igniter same day. Transparent pricing — told me the cost upfront before doing any work. Will use them again for sure.",
    service: "Gas Stove Repair",
    when: "2 months ago",
  },
];

export const FAQS = [
  {
    q: "Who fixes Samsung dryers near me in Decatur?",
    a: "Decatur Solution Works specializes in Samsung dryer repair across Decatur, Stone Mountain, Lithonia, Tucker, and DeKalb County. We stock heating elements, thermostats, and thermal fuses for same-day fixes.",
  },
  {
    q: "Do you repair Whirlpool and Kenmore washers?",
    a: "Yes — Whirlpool and Kenmore washers are two of our most-repaired brands. We handle drainage problems, spin cycle issues, leaks, and control board failures with same-day service.",
  },
  {
    q: "Who repairs LG refrigerators in Stone Mountain?",
    a: "We do! LG refrigerator repair is one of our specialties. Common issues we fix include the LG-typical 'warm fridge / cold freezer' problem, ice maker failures, and compressor issues.",
  },
  {
    q: "Do you repair high-end refrigerator brands?",
    a: "Absolutely. We're certified on Sub-Zero, GE Monogram, KitchenAid, Bosch, and Viking. Many other shops won't touch high-end brands — we do them daily.",
  },
  {
    q: "Do you fix gas stoves and electric ovens?",
    a: "Yes — we repair every brand of gas stove and electric oven, including burner ignition issues, oven heating failures, and control board problems. All technicians are licensed for gas appliance work.",
  },
  {
    q: "How much does appliance repair cost in Decatur GA?",
    a: "Every residential visit starts with a $89 diagnostic fee, credited toward your repair. No hidden fees — you approve the flat-rate quote before any work begins, backed by a 1-year parts & labor warranty (one year on OEM parts).",
  },
  {
    q: "Is there same-day appliance repair near me?",
    a: "Yes! Book before noon Monday through Saturday and we'll do everything we can to get a tech to you the same day across Decatur, Stone Mountain, Lithonia, Tucker, Conyers, and surrounding areas.",
  },
  {
    q: "What brands do you service for appliance repair?",
    a: "Samsung, LG, Whirlpool, GE, GE Monogram, Frigidaire, Kenmore, Bosch, KitchenAid, Amana, Hotpoint, Sub-Zero, Viking, JennAir, Maytag, and more. If it's a major appliance, we likely fix it.",
  },
  {
    q: "How much is the diagnostic fee?",
    a: "Our standard residential diagnostic fee is $89, which covers a complete troubleshooting and inspection by a certified technician — and it's credited toward your repair if you move forward with us.",
  },
  {
    q: "What areas do you service?",
    a: "We're based in Decatur, GA and serve Metro Atlanta, including Atlanta, Stone Mountain, Tucker, Lithonia, Stonecrest, Ellenwood, Avondale Estates, Smyrna, Conyers, Chamblee, Snellville, and surrounding DeKalb County communities.",
  },
  {
    q: "What brands do you service?",
    a: "We service all major brands including Samsung, LG, GE, Whirlpool, Frigidaire, Maytag, KitchenAid, Sub-Zero, and True Commercial — plus many more.",
  },
  {
    q: "Do you handle commercial appliance repair?",
    a: "Yes! In addition to residential service, we repair commercial refrigeration, ice machines, and cooking equipment for businesses.",
  },
];

export const TRUST_BADGES = [
  { label: "Google Guaranteed", icon: "BadgeCheck" },
  { label: "Same-Day Service", icon: "Zap" },
  { label: "Satisfaction Guaranteed", icon: "ShieldCheck" },
  { label: "Transparent Pricing", icon: "DollarSign" },
];

export const COMMERCIAL = [
  {
    title: "Commercial Refrigeration & Rack Repair",
    description:
      "Heavy-duty supermarket racks, walk-in coolers, reach-in cases, and True® units. Trusted by major retail accounts including Walmart Supercenter locations across Metro Atlanta.",
    image: "/site-images/remote/05871c4162.webp",
    href: "/commercial-refrigeration-rack-repair",
  },
  {
    title: "Commercial Appliance Repair",
    description:
      "Restaurants, hotels, laundromats, schools, and offices — Hobart, Speed Queen, Continental, and every major commercial brand. Same-day diagnostic and PM contracts available.",
    image: "/site-images/remote/572724c820.webp",
    href: "/commercial-appliance-repair",
  },
];
